import type { CaseStudyId } from '../server/landingTypes'
import { fairyHomes } from './fairyHomes'
import { oneMind } from './oneMind'
import { peaque } from './peaque'
import { telescope } from './telescope'
import type { CaseStudy, CaseStudyCard, ImageSize } from './types'

export * from './types'
export { fairyHomes, oneMind, peaque, telescope }

/** Every case study, in declaration order. */
export const allCaseStudies: Array<CaseStudy> = [
  fairyHomes,
  telescope,
  oneMind,
  peaque,
]

const byId = Object.fromEntries(
  allCaseStudies.map((study) => [study.id, study]),
) as Record<CaseStudyId, CaseStudy>

/** Landing-page card data, keyed by case-study id. */
export const caseStudies = Object.fromEntries(
  allCaseStudies.map((study) => [study.id, study.card]),
) as Record<CaseStudyId, CaseStudyCard>

/** Image dimensions for every case-study asset, merged from each study. */
export const caseStudyImageSizes: Record<string, ImageSize> = Object.assign(
  {},
  ...allCaseStudies.map((study) => study.imageSizes),
)

export function caseStudyById(id: CaseStudyId): CaseStudy {
  return byId[id]
}
